// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9r-4";
export var collapsed = "_9r-1";
export var headerBar = "_9r-0";
export var leftHeaderContent = "_9r-3";
export var subjectContainer = "_9r-2";